import React from 'react'

import {
  Box,
  Button,
  ButtonColorVariant,
  Display,
  Heading3,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@gousto-internal/citrus-react'

const promptContentByVariant = {
  edit: {
    leaveLabel: 'Cancel Changes',
    message: 'You have made changes to your recipes which have not been saved.',
    stayLabel: 'Keep Editing',
  },
  new: {
    leaveLabel: 'Exit Menu',
    message: "Your chosen recipes may be lost if you don't save your order.",
    stayLabel: 'Keep Choosing',
  },
} as const

export const menuUnsavedChangesModalName = 'menu-unsaved-changes-modal'

type MenuUnsavedChangesPromptProps = {
  onLeave: () => void
  onStay: () => void
  variant: keyof typeof promptContentByVariant
}

export const MenuUnsavedChangesPrompt = ({
  onLeave,
  onStay,
  variant,
}: MenuUnsavedChangesPromptProps) => {
  const promptContent = promptContentByVariant[variant]

  return (
    <Modal
      name={menuUnsavedChangesModalName}
      onRequestClose={onStay}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader>
        <Heading3>Hold up</Heading3>
      </ModalHeader>
      <ModalBody>
        <Text>{promptContent.message}</Text>
      </ModalBody>
      <ModalFooter>
        <Box display={Display.Flex} gap={2} width="100%">
          <Button colorVariant={ButtonColorVariant.Tertiary} onClick={onLeave} width="100%">
            {promptContent.leaveLabel}
          </Button>
          <Button onClick={onStay} width="100%">
            {promptContent.stayLabel}
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  )
}
